import { AccordionStateType, AccordionVariantType, } from '@kubit/web-ui-components/accordionV2';
import { commonStyles } from '../commonStyles';
const commonStateStyles = (FOUNDATIONS) => {
    return {
        rootContainer: {
            background_color: FOUNDATIONS.color_comp_containers_accordion_neutral_bg,
        },
    };
};
export const getNeutralStyles = (FOUNDATIONS, FONT) => {
    return {
        [AccordionVariantType.NEUTRAL]: {
            [AccordionStateType.COLLAPSED]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    ...commonStateStyles(FOUNDATIONS),
                    content: {
                        grid_template_rows: '0fr',
                        padding_top: FOUNDATIONS.spacing_00,
                        padding_bottom: FOUNDATIONS.spacing_00,
                    },
                }),
            },
            [AccordionStateType.EXPANDED]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    ...commonStateStyles(FOUNDATIONS),
                }),
            },
        },
    };
};
//# sourceMappingURL=neutral.js.map